import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data, onDelete, onEdit, canModify}) => {
    const rows = [
        { label: 'Name', value: data.vendorName || 'N/A', fullWidth: true, hideLabel: true, bold: true, fontSize: 14 },
        { label: 'Amount', value: data.paymentAmount?.toFixed(2) },
        { label: 'Invoice', value: data.invoiceStr || '-' },
    ];

    // Same rule as the desktop actions: STAFF can only edit/delete payments created today
    const menuItems = canModify ? [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ] : undefined;

    return (
        <PPMobileCardView
            title={moment(data.paymentDate).format("DD-MM-YYYY")}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
